import "./Thursday.css";
import React from "react";

const Thursday = () => {
  let today = new Date();
  let message;
  let waitingDays;
  let thursday = 4
  let weekDays = 7
  if (today.getDay() == thursday ) {
    message = "🎉 نعم إنه الخميس الونيس ";
  } else {
    waitingDays = thursday  - today.getDay();
    if (Math.sign(waitingDays) == -1) {
      waitingDays = waitingDays + weekDays;
      message = `لا 😔 انتظر ${waitingDays} أيام`;
    }else if(waitingDays === 2){
      message = `لا 😔 انتظر  يومان`;
    }else if(waitingDays === 1) {
      message = `لا 😔 بقي يوم واحد `;
    }else{
      message = `لا 😔 انتظر ${waitingDays} أيام`;
    }
  }

  return (
    <div className="question">
      <h1>هل اليوم هو الخميس ؟ </h1>
      <h1 className="answer">{message}</h1>
    </div>
  );
};

export default Thursday;
